export default __webpack_public_path__ + "static/media/lateCheckout.37089800.jpg";